export default __webpack_public_path__ + "static/media/power.88ecb2f9.svg";